import { useState } from "react"
import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"
import { DataTable } from "@/components/ui/data-table"
import { ColumnDef } from "@tanstack/react-table"

export interface FilteredTableProps<TData> {
  data: TData[]
  columns: ColumnDef<TData>[]
  searchPlaceholder: string
}

export function FilteredTable<TData>({
  data,
  columns,
  searchPlaceholder
}: FilteredTableProps<TData>) {
  const [globalFilter, setGlobalFilter] = useState("")

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder={searchPlaceholder}
            value={globalFilter}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        globalFilter={globalFilter}
        onGlobalFilterChange={setGlobalFilter}
      />
    </div>
  )
}
